<template>
  <v-app>
    <v-app-bar
      app
      color="secondary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="N.V. Havenbeheer Suriname"
          class="shrink mr-2"
          contain
          src="@/assets/logo.png"
          transition="scale-transition"
          width="150"
        />
      </div>

      <v-spacer />

<!--      <v-btn-->
<!--        href="https://github.com/vuetifyjs/vuetify/releases/latest"-->
<!--        target="_blank"-->
<!--        text-->
<!--      >-->
<!--        <span class="mr-2">Latest Release</span>-->
<!--        <v-icon>mdi-open-in-new</v-icon>-->
<!--      </v-btn>-->
    </v-app-bar>

    <v-content>
      <TerminalOperatorAccessPermit />
    </v-content>
    <HBSFooter />
  </v-app>
</template>

<script>
import TerminalOperatorAccessPermit from './views/TerminalOperatorAccessPermit';
import HBSFooter from './components/HBSFooter';

export default {
  name: 'App',

  components: {
    HBSFooter,
    TerminalOperatorAccessPermit,
  },

  data: () => ({
    //
  }),
};
</script>
